import { api } from "../api";
import { reportSwallowed } from "./reportSwallowed";
import { useFlagDismissBus } from "../stores/flagDismissBus";

// tsx); without it a teammate's dismissal never arrives and clearing browser storage resurrects
// flags the server still has dismissed.

const KEY = (fieldId: string) => `sm_flag_dismissals:${fieldId}`;

export function dismissKey(flagKey: string, year: number): string {
  return `${flagKey}:${year}`;
}

export function loadDismissals(fieldId: string): Set<string> {
  try {
    const raw = localStorage.getItem(KEY(fieldId));
    const arr = raw ? (JSON.parse(raw) as unknown) : [];
    return new Set(
      Array.isArray(arr)
        ? arr.filter((x): x is string => typeof x === "string")
        : [],
    );
  } catch {
    return new Set();
  }
}

function save(fieldId: string, keys: Set<string>) {
  try {
    localStorage.setItem(KEY(fieldId), JSON.stringify([...keys]));
  } catch {
    /* storage full/blocked — the server copy (once live) still records it */
  }
  useFlagDismissBus.getState().bump();
}

export function dismissFlag(fieldId: string, flagKey: string, year: number) {
  const keys = loadDismissals(fieldId);
  keys.add(dismissKey(flagKey, year));
  save(fieldId, keys);
  api
    .addFlagDismissal(fieldId, dismissKey(flagKey, year))
    .catch((err) => reportSwallowed("add flag dismissal", err));
}

export function undismissFlag(fieldId: string, flagKey: string, year: number) {
  const keys = loadDismissals(fieldId);
  keys.delete(dismissKey(flagKey, year));
  save(fieldId, keys);
  api
    .removeFlagDismissal(fieldId, dismissKey(flagKey, year))
    .catch((err) => reportSwallowed("remove flag dismissal", err));
}

/* * Server → local hydration (server wins), mirroring hydrateFertRx. Called on login + org switch. */
export async function hydrateFlagDismissals(): Promise<void> {
  try {
    const all = await api.listFlagDismissals();
    for (const [fieldId, keys] of Object.entries(all)) {
      try {
        localStorage.setItem(KEY(fieldId), JSON.stringify(keys));
      } catch {
        /* ignore */
      }
    }
    useFlagDismissBus.getState().bump();
  } catch {
    /* transient read failure — local copies stand until the next hydrate */
  }
}

/* * Purge a field's local dismissals (delete-field cascade, mirroring the other FE-local purges). */
export function purgeDismissals(fieldId: string) {
  try {
    localStorage.removeItem(KEY(fieldId));
  } catch {
    /* ignore */
  }
  useFlagDismissBus.getState().bump();
}
